/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';

const ToggleSwitch = (props) => {
  const { choices } = props;
  if (!choices || !choices.length) {
    return null;
  }

  const activeColorClass = props.isOff ? props.offClassName : props.onClassName;
  const withoutLabels = choices.every((c) => !c.label);
  const styleClass = classnames(
    'cmp-toggle-switch',
    activeColorClass,
    {
      disabled: props.disabled,
      'without-labels': withoutLabels,
    }
  );

  return (
    <div className={styleClass}>
      {
        choices.map((c, index) => {
          const inputId = `toggle-switch-${c.name}-${index}`;

          return (
            <div key={index}>
              <input
                id={inputId}
                type="radio"
                name={c.name}
                value={c.value}
                onChange={props.disabled ? undefined : () => {}}
                onClick={props.disabled ? undefined : props.onChange}
                checked={props.value === c.value}
                disabled={props.disabled}
              />
              <label
                className={props.value === c.value ? props.switchClassName : null}
                htmlFor={inputId}
              >
                <div className="font-caption-1">
                  {
                    c.label && <FormattedMessage id={c.label} />
                  }
                </div>
              </label>
            </div>
          );
        })
      }
    </div >
  );
};
ToggleSwitch.propTypes = {
  value: PropTypes.any,
  choices: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  onClassName: PropTypes.string,
  offClassName: PropTypes.string,
  switchClassName: PropTypes.string,
  isOff: PropTypes.bool,
  disabled: PropTypes.bool,
};

export const ProfileThemedToggleSwitch = (props) => (
  <ToggleSwitch
    {...props}
    onClassName="bkgd-color-profile border-color-profile font-color-gsLightest"
    offClassName="bkgd-color-white border-color-gsLight font-color-profile"
    switchClassName="bkgd-color-white border-color-gsLight font-color-profile"
  />
);

export const GreenRedToggleSwitch = (props) => (
  <ToggleSwitch
    {...props}
    onClassName="bkgd-color-success border-color-success"
    offClassName="bkgd-color-error border-color-error"
  />
);

export const GreenWhiteToggleSwitch = (props) => (
  <ToggleSwitch
    {...props}
    onClassName="bkgd-color-success border-color-success"
    offClassName="bkgd-color-white border-color-gsLight"
    switchClassName="bkgd-color-white border-color-gsLight"
  />
);

export default ToggleSwitch;
